import BaseCellRenderer, { IBaseCellRendererParams } from "./BaseCellRenderer";
import {ReactComponent as EditIcon} from "assets/images/edit.svg";

export default function EditablePercentCellRenderer(props: IBaseCellRendererParams<number>) {
    const decimal: number | null | undefined = props.valueFormatted != null ? (props.valueFormatted === "" ? null : Number.parseFloat(props.valueFormatted)) : typeof props.value === "object" ? props.value?.value : props.value;
    return (
        <BaseCellRenderer {...props}>
            {(decimal != null && !Number.isNaN(decimal) && decimal > 0)? <>{decimal.formatAsPrice(true)}%</> :
            <>
            <div className="w-100 hover-show" >               
                <EditIcon height="14" width="14" fill="#34BBB9" style={{marginLeft: -15}}/>                  
            </div>
            </>
            }
        </BaseCellRenderer>
    );
}